/* eslint @typescript-eslint/naming-convention: 0 */
import type { MapSourcePage, MapViewLayout } from '@/wabunka-src/common/utils/googleAnalytics/common/mapSearch';
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export interface MapViewOpenParams {
  source_page: MapSourcePage;
  layout: MapViewLayout;
}

/**
 * 発火タイミング：一覧でマップが表示状態になった際（Desktop=スプリット描画 / Mobile=map トグルで全画面）。
 * 一覧 Dynamic マップのコスト母数（Option A 永続インスタンス ≒ 1セッション1load）。
 * ダッシュボードのブロック②④⑦で使用（JCAT-4824）。
 */
export const sendGAWabunkaMapViewOpenEvent = (sourcePage: MapSourcePage, layout: MapViewLayout) => {
  sendWabunkaGAEvent('map_view_open', { source_page: sourcePage, layout });
};
